import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { LocalCurrencyNote } from './LocalCurrencyNote';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { PRODUCTS } from './MetaPixel';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard, CheckCircle2 } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Chile',
    product: 'Compró la Biblioteca',
    text: 'Antes improvisaba cada sesión. Ahora abro el módulo y en minutos tengo todo estructurado y listo.',
    bg: 'bg-brandViolet'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'Colombia',
    product: 'Compró la Biblioteca',
    text: 'Lo compré con desconfianza y me sorprendió: está mucho más completo y organizado de lo que esperaba.',
    bg: 'bg-brandIndigo-electric'
  }, {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'México',
    product: 'Compró la Biblioteca',
    text: 'Las meditaciones y los rituales me salvaron. Se nota que las sesiones tienen orden de principio a fin.',
    bg: 'bg-brandViolet'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Uruguay',
    product: 'Compró la Biblioteca',
    text: 'Me ahorró años de búsqueda dispersa. Todo está conectado y el sistema realmente funciona.',
    bg: 'bg-brandIndigo-electric'
  }];
  return <Section className="bg-bg-alt" data-id="element-166" data-mp="3gdwqfjatt4ai">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-167" data-mp="3ubla4nt5q5dz">
        <h2 className="font-display font-extrabold uppercase md:text-[40px] text-txt-primary mb-3 md:mb-4 text-[26px]" data-id="element-168" data-mp="3u8z2ypa6hrwa">
          Lo que dicen <span className="text-brandViolet" data-id="element-169" data-mp="1zwsewpw6rgmk">los terapeutas</span>
        </h2>
        <div className="inline-flex items-center gap-2 bg-bg-card border border-line rounded-full px-4 py-2" data-id="element-170" data-mp="1uy7fgsord0z6">
          <div className="flex text-gold" data-id="element-171" data-mp="3v0qikcs1bqs1">
            {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-current" data-id="element-172" data-mp="3u5qcpq8uctf" data-mpi={j} />)}
          </div>
          <span className="font-sans font-bold text-txt-primary text-sm" data-id="element-173" data-mp="7vr1a5j7wh0z">
            4.9/5
          </span>
          <span className="font-sans text-txt-muted text-xs md:text-sm" data-id="element-174" data-mp="culvs4qjru0x">
            · +300 terapeutas de Latinoamérica
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-175" data-mp="htorgykn0nw8">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-176" data-mp="rjqbnf9vdm5v" data-mpi={i}>
            <div className="bg-bg-card p-4 md:p-5 rounded-[16px] border border-line h-full flex flex-col" data-id="element-177" data-mp="rk9tkvzisajw">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-178" data-mp="vkjzk8nbb0yr">
                <div className={`w-9 h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-xs shrink-0`} data-id="element-179" data-mp="10lhiwok2611u">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-180" data-mp="1ford1cknfd6v">
                  <div className="flex text-gold mb-0.5" data-id="element-181" data-mp="1antvn27gqn6f">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-182" data-mp="15oicjmjmj5lo" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[13px] leading-tight" data-id="element-183" data-mp="11p01rjlioawk">
                    {t.name}
                  </p>
                  <p className="text-[11px] font-sans text-txt-muted" data-id="element-184" data-mp="1teur3g9dk0l8">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[13px] md:text-[14px] leading-[1.5] italic mb-2.5" data-id="element-185" data-mp="1ombfgou8zfj2">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandViolet mt-auto" data-id="element-186" data-mp="2h4yx1ua1ccfe">
                {t.product}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-bg-base" data-id="element-187" data-mp="21uilgi6zfvzn">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-188" data-mp="21vlh13f92mlw">
        <div className="bg-bg-card border border-[rgba(34,197,94,0.2)] rounded-[20px] p-6 md:p-10 relative overflow-hidden" data-id="element-189" data-mp="1nvam9patknvg">
          <div className="absolute inset-0 bg-gradient-to-b from-[rgba(212,164,28,0.05)] to-transparent pointer-events-none" data-id="element-190" data-mp="1rxnpa5y6m7oj"></div>
          <ShieldCheck size={70} className="mx-auto text-success mb-5 md:mb-6 relative z-10" data-id="element-191" data-mp="2fmytjxeqqk7f" />
          <h2 className="font-display font-extrabold uppercase text-[22px] md:text-[38px] leading-[1.2] text-txt-primary mb-6 md:mb-8 relative z-10" data-id="element-192" data-mp="26tv9355oh73a">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body space-y-3 md:space-y-4 mb-6 md:mb-8 relative z-10" data-id="element-193" data-mp="2ykj9gezj28fw">
            <p data-id="element-194" data-mp="33dvwikok676j">Abres los módulos. Los usas en tus sesiones.</p>
            <p className="font-sans font-bold text-lg md:text-xl text-txt-primary leading-snug py-2" data-id="element-195" data-mp="rvr2zkku209h">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-196" data-mp="11mlzrivpgi96" />
              devolución del 100%.
            </p>
            <p data-id="element-197" data-mp="11lu2m3mgmcgs">Sin formularios. Sin complicaciones. Sin vueltas.</p>
          </div>
          <p className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-txt-muted relative z-10" data-id="element-198" data-mp="wotw5rlp77p5">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si ya tengo conocimientos previos de chakras?',
    a: 'Sí, está diseñada exactamente para eso. No es una introducción básica. Es para quienes ya tienen experiencia y quieren profundizar, organizar y ampliar su práctica.'
  }, {
    q: '¿En qué moneda pago?',
    a: 'El precio está en USD pero se convierte automáticamente a tu moneda local al finalizar la compra. Podés pagar con tarjeta, débito o métodos locales según tu país.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de la compra recibís acceso a los 11 recursos en formato PDF. En menos de 5 minutos ya podés empezar.'
  }, {
    q: '¿Necesito alguna certificación previa para aprovecharlo?',
    a: 'No. Solo es recomendable tener algún contacto previo con el mundo energético o las prácticas holísticas.'
  }, {
    q: '¿Funciona si trabajo de forma independiente y no en un centro?',
    a: 'Perfectamente. La biblioteca está pensada para terapeutas independientes, en centros holísticos, online o presencial.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días desde la compra. Si no es lo que esperabas, devolvemos el 100% sin preguntas ni formularios.'
  }, {
    q: '¿Puedo usar la biblioteca con mis consultantes?',
    a: 'Sí. Podés aplicar los conocimientos, meditaciones, afirmaciones y recursos dentro de tus sesiones con consultantes.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-bg-alt" data-id="element-199" data-mp="3977uiw6okaf8">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-200" data-mp="39422b82r8sfa">
        <h2 className="font-display font-extrabold uppercase text-[24px] md:text-[38px] leading-[1.2] text-txt-primary text-center mb-8 md:mb-10" data-id="element-201" data-mp="346adimxepmfb">
          ❓ LO QUE MÁS NOS <span className="text-brandViolet" data-id="element-202" data-mp="2zacto6mxpxxs">PREGUNTAN</span>
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-203" data-mp="2ua70gm10o3dl">
          {faqs.map((faq, i) => <div key={i} className={`bg-bg-card border border-line rounded-[16px] overflow-hidden transition-colors ${openIndex === i ? 'bg-bg-highlight' : ''}`} data-id="element-204" data-mp="2phdyg5wxn957" data-mpi={i}>
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-205" data-mp="2gj29s9fmmlfe">
                <span className="font-sans font-bold text-[14px] md:text-[16px] text-txt-primary" data-id="element-206" data-mp="3vd8ye4wtvsl3">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-brandViolet shrink-0" size={20} data-id="element-207" data-mp="3lfuiq7iqb7tu" /> : <ChevronDown className="text-txt-muted shrink-0" size={20} data-id="element-208" data-mp="3qdw9lemecbfv" />}
              </button>
              {openIndex === i && <div className="px-5 pb-5 md:px-6 md:pb-5 font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body border-t border-line pt-4" data-id="element-209" data-mp="3bneyt4nvg96b">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: 'Horas buscando herramientas dispersas',
    costo: 'Tiempo perdido cada semana'
  }, {
    sin: 'Sesiones sin estructura',
    costo: 'Consultante que no regresa'
  }, {
    sin: 'Sin técnicas complementarias',
    costo: 'Siempre los mismos recursos'
  }, {
    sin: 'Sin biblioteca de consulta',
    costo: 'Dependencia de fuentes externas'
  }, {
    sin: 'Fin de semana buscando en internet',
    costo: 'Mismo ciclo cada semana'
  }];
  return <Section className="bg-bg-base" data-id="element-210" data-mp="2j1gokio6nu3c">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-211" data-mp="2x2t0mj083bjy">
        <h2 className="font-display font-extrabold uppercase text-[26px] md:text-[40px] leading-[1.2] text-center text-txt-primary mb-8 md:mb-12" data-id="element-212" data-mp="2x1hwuj6s23su">
          ⚖️ ¿CUÁNTO CUESTA
          <br data-id="element-213" data-mp="36svsgfvlyjgp" />
          <span className="text-brandViolet" data-id="element-214" data-mp="36rkrsoxglrtt">NO TENERLO?</span>
        </h2>

        <div className="bg-bg-card rounded-[16px] md:rounded-[20px] overflow-hidden border border-line mb-8 md:mb-10" data-id="element-215" data-mp="31t134grhe1xr">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5" data-id="element-216" data-mp="3grv2o2w0un5t">
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-muted" data-id="element-217" data-mp="3bs8q7vo0pay2">
              Sin la Biblioteca
            </div>
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-primary pl-3 md:pl-5 border-l border-line" data-id="element-218" data-mp="3dzbo1z4e7pjm">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-219" data-mp="348qs6jg3sz4e">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5 items-center" data-id="element-220" data-mp="307dl6619ypvw" data-mpi={i}>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-txt-muted pr-2" data-id="element-221" data-mp="p4hlxe64z5a">
                  {row.sin}
                </div>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-danger font-medium pl-3 md:pl-5 border-l border-line flex items-center gap-1.5" data-id="element-222" data-mp="3nult6vq38d1m">
                  <span data-id="element-223" data-mp="2chsypd5wxahv">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <p className="font-sans font-bold text-[14px] md:text-xl text-center text-txt-primary w-full mx-auto" data-id="element-224" data-mp="27gdgrtz17k3p">
          Tu próxima sesión puede ser diferente...
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-bg-alt border-t border-line pt-12 md:pt-16 pb-20 md:pb-24" data-id="element-225" data-mp="vz102f8bttih">
      <FadeIn className="max-w-[700px] mx-auto text-center" data-id="element-226" data-mp="10slr1nbi5n86">
        {/* Urgency intro copy */}
        <div className="mb-8 md:mb-10" data-id="element-227" data-mp="15plxhzc9krzt">
          <p className="font-display font-extrabold uppercase text-[22px] md:text-[34px] leading-[1.25] text-txt-primary" data-id="element-228" data-mp="1ap8aq8s3e88m">
            Puedes seguir buscando{' '}
            <span className="text-brandViolet" style={{
            textShadow: '0 0 12px rgba(139,92,246,0.28)'
          }} data-id="element-229" data-mp="1fp320dfs4zu7">
              herramientas dispersas
            </span>
            ,
            <br data-id="element-230" data-mp="3lgqay9lzbo2h" />
            o entrar con todo organizado y listo.
          </p>
          <p className="font-display font-black uppercase text-[26px] md:text-[38px] leading-[1.2] text-brandViolet animate-pulse mt-2" data-id="element-231" data-mp="smrscy9v17sh">
            Tú decides.
          </p>
        </div>

        <div className="mb-10 md:mb-12" data-id="element-232" data-mp="nq1bw9u58a6j">
          <div className="inline-flex items-center gap-1.5 bg-danger/15 border border-danger/40 text-danger font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 rounded-full mb-3 animate-pulse" data-id="element-233" data-mp="11npwrho7nhbl">
            <span className="w-1.5 h-1.5 rounded-full bg-danger animate-pulse" data-id="element-234" data-mp="1bk2owb43xn48"></span>
            🚨 ÚLTIMA OPORTUNIDAD
          </div>
          <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-brandViolet mb-3 md:mb-4" data-id="element-235" data-mp="16kq0vn1i2a02">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className="inline-flex items-center gap-2 md:gap-3 bg-bg-card border-2 border-brandViolet px-5 py-3 md:px-6 md:py-4 rounded-[14px] shadow-[0_0_30px_rgba(139,92,246,0.4)] animate-glow-button" data-id="element-236" data-mp="1gcvu103hmxgu">
            <span className="font-display font-black text-[30px] md:text-[40px] text-brandViolet leading-none" data-id="element-237" data-mp="1pevb1sei61js">
              {hours.toString().padStart(2, '0')}
            </span>
            <span className="font-display font-black text-[30px] md:text-[40px] text-brandViolet leading-none" data-id="element-238" data-mp="2dwm20wqi5svx">
              :
            </span>
            <span className="font-display font-black text-[30px] md:text-[40px] text-brandViolet leading-none" data-id="element-239" data-mp="23zr003v0tacw">
              {minutes.toString().padStart(2, '0')}
            </span>
            <span className="font-display font-black text-[30px] md:text-[40px] text-brandViolet leading-none" data-id="element-240" data-mp="1q69lwyl3spu9">
              :
            </span>
            <span className="font-display font-black text-[30px] md:text-[40px] text-brandViolet leading-none" data-id="element-241" data-mp="1gay427eef2ia">
              {seconds.toString().padStart(2, '0')}
            </span>
          </div>
          <p className="font-sans font-bold text-[11px] md:text-[13px] text-danger mt-3 uppercase tracking-[1.5px]" data-id="element-242" data-mp="1798c90glu1jz">
            Después sube. No vuelve a este precio.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10 md:mb-12" data-id="element-243" data-mp="14855p1g10rxf">
          <div className="bg-bg-card rounded-[22px] p-5 md:p-8 border-2 border-brandViolet text-left shadow-[0_0_50px_rgba(139,92,246,0.2),inset_0_0_30px_rgba(139,92,246,0.03)]" data-id="element-244" data-mp="149q26wlwikxx">
            <h4 className="font-display font-extrabold uppercase text-[16px] md:text-[22px] leading-[1.25] text-txt-primary text-center" data-id="element-245" data-mp="ug98rtpof7us">
              BIBLIOTECA MAESTRA DEL CÓDIGO DE LOS{' '}
              <span className="text-brandViolet" data-id="element-246" data-mp="lip4ebwiovfy">CHAKRAS™</span>
            </h4>
            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mt-2 mb-3 md:mb-4" data-id="element-247" data-mp="ghj9q8jaqy3s">
              Lo que incluye:
            </p>

            <ul className="space-y-2 md:space-y-2.5" data-id="element-248" data-mp="7io34vccblzy">
              {['6 Módulos principales — 475 páginas', '5 Bonos exclusivos incluidos', 'Afirmaciones, rituales, meditaciones y agenda', 'Acceso inmediato y para siempre'].map(item => <li key={item} className="flex items-start gap-2" data-id="element-249" data-mp="3jt0j2xuteiwp">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-250" data-mp="3orbrr59dindc" />
                  <span className="font-sans text-[12.5px] md:text-[15px] leading-[1.45] text-txt-body" data-id="element-251" data-mp="3tl6k0x31oao1">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-4 md:mt-5 pt-3 md:pt-4 border-t border-line text-center" data-id="element-252" data-mp="30wr8wln1achz">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-253" data-mp="35vlqjk99lv0i">
                Precio original
              </p>
              <p className="font-display font-black text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-254" data-mp="3euyzmbth8hkp">
                USD $79
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandViolet/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-255" data-mp="u2x7w01vhblt">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandViolet" data-id="element-256" data-mp="2q5a1rzbtrk2x">
                Acceso completo hoy por
              </p>
              <p className="font-display font-black text-[40px] md:text-[54px] leading-none text-brandViolet mt-1" data-id="element-257" data-mp="303y7pzqjc8q9">
                $15{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-258" data-mp="2v4d9jrj6w4el">
                  USD
                </span>
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-259" data-mp="22itqwow9c2pl">
                Pago único · Incluye garantía de 7 días
              </p>
            </div>

            <LocalCurrencyNote className="mt-3 md:mt-4" data-id="element-260" data-mp="2cff1dpr1q60t" />

            <div className="mt-4 md:mt-5" data-id="element-261" data-mp="2cdvkbwxkfqxz">
              <CTAButton href={PRODUCTS.biblioteca.checkoutUrl} fullWidth trackingProduct="biblioteca" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[14px] md:!text-base" data-id="element-262" data-mp="1op2hrhmfukue">
                💜 QUIERO LA BIBLIOTECA COMPLETA
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 font-sans text-[12px] md:text-[13px] text-txt-muted" data-id="element-263" data-mp="3mezjz5hnft05">
          <span className="flex items-center gap-2" data-id="element-264" data-mp="3qfjf63inwmjn">
            <Lock size={14} data-id="element-265" data-mp="hz86p48pbj0h" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-266" data-mp="hxndbhy4i647">
            <Clock size={14} data-id="element-267" data-mp="mxhz5731k5ie" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-268" data-mp="8z1udloqop2w">
            <ShieldCheck size={14} data-id="element-269" data-mp="8yiesbmkacs1" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-270" data-mp="dwtommcuwna9">
            <CreditCard size={14} data-id="element-271" data-mp="2tohho6or1vns" /> Tarjeta | Débito | Pago local en tu moneda
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-bg-base border-t border-line py-12 px-6" data-id="element-272" data-mp="3pe776faonl10">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-273" data-mp="3pfibcg81iusn">
        <div data-id="element-274" data-mp="3lbiw00yhy20v">
          <h2 className="font-display font-black text-base md:text-xl text-txt-primary mb-1 leading-snug" data-id="element-275" data-mp="3lbskfk3w814g">
            🔮 BIBLIOTECA MAESTRA DEL CÓDIGO DE LOS CHAKRAS™
          </h2>
          <p className="font-sans font-bold text-sm text-brandViolet" data-id="element-276" data-mp="3bffwz3yxyji5">
            by CENTER SHOP DIGITAL
          </p>
        </div>

        <p className="font-sans text-[13px] text-txt-muted max-w-md mx-auto" data-id="element-277" data-mp="cvza5n05nlvu">
          La biblioteca profesional número 1 para terapeutas energéticos en
          Latinoamérica. Porque profundizar tu práctica no debería costarte años
          de búsqueda dispersa.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 font-sans text-[13px] text-txt-muted pt-4" data-id="element-278" data-mp="3ucgz8h1425ie">
          <a href="mailto:soportecentershop95@gmail.com" className="hover:text-txt-primary transition-colors" data-id="element-279" data-mp="vp30ozi2tim8">
            📧 soportecentershop95@gmail.com
          </a>
          <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-280" data-mp="136sy3ebylsfb">
            📲 @centershop.digital
          </a>
        </div>

        <div className="pt-8 border-t border-line space-y-3" data-id="element-281" data-mp="184ud9o69l7li">
          <p className="font-sans text-xs text-txt-faint" data-id="element-282" data-mp="1d4yu5fb344c9">
            © 2024 Center Shop Digital. Todos los derechos reservados. Precios
            en dólares (USD) · Cobro en tu moneda local.
          </p>
          <p className="space-x-4 font-sans text-xs text-txt-faint" data-id="element-283" data-mp="1m5dhek7lztie">
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-284" data-mp="1m3keng049tfo">
              Términos y condiciones
            </a>
            <span data-id="element-285" data-mp="1vvzti4g4a1wc">·</span>
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-286" data-mp="1vuf22np3mz2p">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};